import React, { CSSProperties, useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';

function Header() {
    type HoverIndexType = number | null;
    const [hoverIndex, setHoverIndex] = useState<HoverIndexType>(null);

    const styles = {
        navbar: {
            backgroundColor: 'white',
            paddingLeft: '0px',
            paddingRight: '0px',
        },
        navLink: (index: number): CSSProperties => ({
            color: hoverIndex === index || index === 0 ? '#0072cc' : '#45504d',
            padding: '24px',
            textTransform: 'uppercase',
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '0.15px',
            lineHeight: 1.5,
            fontFamily: '"Montserrat", Arial, sans-serif',
            position: 'relative',
        }),
        activeUnderline: {
            content: '""',  // Note: content property usually requires double quotes inside single quotes for pseudo-elements
            position: 'absolute' as const, // explicitly casting the type here
            bottom: '1.5em',
            left: 0,
            width: '100%',
            height: '4px',
            backgroundColor: '#0072cc',
        } as CSSProperties,  // explicitly declare the type for the object
        button: {
            color: 'white',
            backgroundColor: '#0072cc', // blue color
        } as CSSProperties,
        requestQuoteButton: {
            fontFamily: '"Montserrat", Arial, sans-serif',
            fontSize: '16px',
            fontWeight: 'normal',
            backgroundColor: '#0072cc',
            color: 'white',
            border: '2px solid #0072cc',
            padding: '10px 25px',
            margin: '0px 16px',
            textTransform: 'none',
            borderRadius: '2em',
        } as CSSProperties,
    };

    return (
        <Navbar style={styles.navbar} bg="light" expand="lg">
            <Container>
                <Navbar.Brand href="https://bluecanoelearning.com/">
                    <img
                        src="/bcimage.png"
                        className="retina-logo normal-logo"
                        alt="Blue Canoe Learning"
                        width="150"
                        height="35"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse
                    id="basic-navbar-nav"
                    className="justify-content-end"
                >
                    <Nav className="ml-auto align-items-center">
                        {[
                            'Wordsmith',
                            'Businesses',
                            'Organizations',
                            'Teachers',
                            'Support',
                        ].map((text, index) => (
                            <Nav.Link
                                key={index}
                                active={hoverIndex === index}
                                style={styles.navLink(index)}
                                onMouseEnter={() => setHoverIndex(index)}
                                onMouseLeave={() => setHoverIndex(null)}
                                href={
                                    index === 0
                                        ? 'https://wordsmith.bluecanoelearning.com'
                                        : `https://bluecanoelearning.com/${text.toLowerCase()}/`
                                }
                            >
                                {text}
                                {index === 0 && (
                                    <div style={styles.activeUnderline} />
                                )}
                            </Nav.Link>
                        ))}
                        <Nav.Link
                            className="pr-0"
                            href="https://bluecanoelearning.com/organizations/#form"
                        >
                            <Button
                                variant="primary"
                                style={styles.requestQuoteButton}
                                href="https://bluecanoelearning.com/organizations/#form"
                            >
                                Request a quote
                            </Button>
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;
